import { Typography } from "@mui/material";
import { useState } from "react";

const EllipsisLabel = ({
  text,
  maxLength = 20,
  fontSize = 12,
  fontWeight = 700,
}) => {
  const [expanded, setExpanded] = useState(false);

  if (!text) return "-";

  const isLong = text.length > maxLength;

  return (
    <Typography
      fontSize={fontSize}
      fontWeight={fontWeight}
      component="span"
      onClick={() => isLong && setExpanded(prev => !prev)}
      sx={{
        cursor: isLong ? "pointer" : "default",
        userSelect: "none",
        transition: "all .2s ease",
      }}
    >
      {expanded || !isLong ? text : `${text.substring(0, maxLength)}...`}
    </Typography>
  );
};

export default EllipsisLabel;
